"use strict";

exports.__esModule = true;
exports.TimestampSelectorPopover = void 0;
var _react = _interopRequireWildcard(require("react"));
var _datetime = require("@blueprintjs/datetime");
var _icons = require("@blueprintjs/icons");
var _core = require("@blueprintjs/core");
var _Translator = require("../../Core/Translator");
var _excluded = ["selected", "onSelect"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Allows a user to select a timestamp from a calendar.
 */
var TimestampSelectorPopover = exports.TimestampSelectorPopover = /*#__PURE__*/function (_Component) {
  function TimestampSelectorPopover() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      isOpen: false
    };
    _this.handleOpenClick = function () {
      _this.setState({
        isOpen: true
      });
    };
    _this.handleClose = function () {
      _this.setState({
        isOpen: false
      });
    };
    _this.handleDateChange = function (date) {
      if (date == null) return;
      var _this$props = _this.props,
        selected = _this$props.selected,
        onSelect = _this$props.onSelect;
      var previous = selected.length > 0 ? selected[0] : new Date();
      var merged = new Date(date);
      merged.setHours(previous.getHours(), previous.getMinutes(), previous.getSeconds(), previous.getMilliseconds());
      onSelect([merged]);
    };
    _this.handleTimeChange = function (time) {
      var _this$props2 = _this.props,
        selected = _this$props2.selected,
        onSelect = _this$props2.onSelect;
      var previous = selected.length > 0 ? selected[0] : new Date();
      var merged = new Date(previous);
      merged.setHours(time.getHours(), time.getMinutes(), time.getSeconds(), time.getMilliseconds());
      onSelect([merged]);
    };
    return _this;
  }
  _inheritsLoose(TimestampSelectorPopover, _Component);
  var _proto = TimestampSelectorPopover.prototype;
  _proto.render = function render() {
    var _this2 = this;
    // eslint-disable-next-line no-unused-vars
    var _this$props3 = this.props,
      selected = _this$props3.selected,
      onSelect = _this$props3.onSelect,
      extra = _objectWithoutPropertiesLoose(_this$props3, _excluded);
    var value = selected.length > 0 ? selected[0] : null;
    return /*#__PURE__*/_react["default"].createElement(_Translator.Translator, null, function (_ref) {
      var translate = _ref.translate,
        intl = _ref.intl;
      return /*#__PURE__*/_react["default"].createElement(_core.Popover, {
        isOpen: _this2.state.isOpen,
        onClose: _this2.handleClose,
        content: /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_datetime.DatePicker, _extends({
          value: value,
          onChange: _this2.handleDateChange
        }, extra)), /*#__PURE__*/_react["default"].createElement(_datetime.TimePicker, {
          value: value,
          onChange: _this2.handleTimeChange
        }))
      }, /*#__PURE__*/_react["default"].createElement(_core.Button, {
        icon: _icons.IconNames.TIME,
        onClick: _this2.handleOpenClick,
        text: value ? intl.formatDate(value, {
          year: "numeric",
          month: "long",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit"
        }) : translate("TimestampSelector.placeholder", "Select Date / Time")
      }));
    });
  };
  return TimestampSelectorPopover;
}(_react.Component);